
const digest = 'cb057dd341adcb1f495db3fa18208e084181bba1c0ca23d5c336b6b0057d1d40';
const classes = {"wrapper":"_wrapper_19285_1"};
const css = `._wrapper_19285_1 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  white-space: nowrap;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  